// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__DxrCJ","back":"Nav_back__2U5rf","show":"Nav_show__0MOC8","link":"Nav_link__zWsNf","title":"Nav_title__Iwbba","showTitle":"Nav_showTitle__2+gkg"};